import moment from 'moment';
import 'moment/dist/locale/es';
import { createContext, FC, PropsWithChildren, useCallback, useEffect, useState } from 'react';
import { IntlProvider } from 'use-intl';

import { messages } from '../i18n';
import { DEFAULT_LOCALE, getInitialLocale, saveLocale } from '../i18n/locale';
import Locale from '../interfaces/Locale';

interface LocaleContextType {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

moment.locale('en');

const LocaleContext = createContext<LocaleContextType>({
  locale: DEFAULT_LOCALE,
  setLocale: () => undefined,
});

export const LocaleProvider: FC<PropsWithChildren> = ({ children }) => {
  const [locale, setCurrentLocale] = useState(getInitialLocale);

  const setLocale = useCallback((nextLocale: Locale) => {
    setCurrentLocale(nextLocale);
    saveLocale(nextLocale);
  }, []);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  );
};

export default LocaleContext;
